/*
 * @Author: your name
 * @Date: 2021-04-10 17:45:31
 * @LastEditTime: 2021-04-26 13:59:17
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /zmbiz-mobile-work-front/src/config/menu.js
 */

export default {
  zhaopin: {
    id: 1,
    title: '招聘管理',
    path: '/pages/interviewArrangement',
    url: 'https://web-data.zmlearn.com/image/dYs7wmBQM7RpiLHeWhnzmh/interview.png',
  },
  book: {
    id: 2,
    title: '掌经阁',
    path: '/books/list',
    url: 'https://web-data.zmlearn.com/image/A85DFcxfscBgx8BvG5ajL/book.png',
  },
  pact: {
    id: 3,
    title: '电子合同',
    path: '/pact/detail',
    url: 'https://web-data.zmlearn.com/image/p46vKB4JPSTkqegcR4whRB/pact.png',
  },
  finance: {
    id: 4,
    title: '财务配置管理',
    path: '/finance/manage',
    url: 'https://web-data.zmlearn.com/image/9XiHKMRHvGk6RSNt1uBAi1/finance.png',
  },
  pay: {
    id: 5,
    title: '薪资查询',
    path: '/pay/login',
    url: 'https://web-data.zmlearn.com/image/2qkykUC2iA5VGMraWSY3DN/pay.png',
  },
  // meal: {
  //   id: 6,
  //   title: '奋斗餐',
  //   path: '/meal/manage',
  //   url: 'https://web-data.zmlearn.com/image/7XMbMm9yj3sEMiTNeJqsDr/meal.png',
  // },

  assets: {
    id: 7,
    title: '资产管理',
    path:
      process.env.VUE_APP_RUN_ENV === 'prod'
        ? 'https://zm-property-wechat.zmlearn.com/dingding/index.do'
        : 'https://zm-property-wechat.zmaxis.com/dingding/index.do',
    url: 'https://web-data.zmlearn.com/image/5FuFdKbHd8Pk1vGantxCtC/assets.png',
  },
  station: {
    id: 8,
    title: '工位线上化',
    path: '/stationOnline',
    url: 'https://web-data.zmlearn.com/image/i1VHP7fUbFm2BGkKThvsaY/stationMenu.png',
  },
};
